export const contactPageTranslations = {
  nl: {
    title: "Neem Contact Op",
    subtitle: "We horen graag van u! Of u nu een vraag heeft, een bestelling wilt plaatsen of informatie wilt over catering, hier kunt u ons bereiken.",
    contactInfoTitle: "Contactinformatie",
    address: "Ams Food Market\nGriend 36-15, 8225 TE Lelystad, Nederland",
    phone: "064 111 1632",
    email: "amsfoodmarket@hotmail.com",
    whatsapp: "Word lid van onze WhatsApp Groep",
    googleReview: "Laat een Google Review achter",
    kvk: "KVK: 87975858",
    openingHoursTitle: "Openingstijden Winkel",
    days: {
      monday: "Maandag",
      tuesday: "Dinsdag",
      wednesday: "Woensdag",
      thursday: "Donderdag",
      friday: "Vrijdag",
      saturday: "Zaterdag",
      sunday: "Zondag",
    },
    hours: {
      monTue: "15:00 – 19:00",
      wedThuFri: "15:00 – 19:00",
      saturday: "08:30 – 16:00",
      saturdayNote: "Alleen Markt",
      sunday: "15:00 – 19:00",
    },
    locationTitle: "Onze Locatie",
    mapTitle: "Locatie Ams Food Market Lelystad",
    openInGoogleMaps: "Open in Google Maps",
  },
  en: {
    title: "Contact Us",
    subtitle: "We'd love to hear from you! Whether you have a question, want to place an order, or need information about catering, here's how you can reach us.",
    contactInfoTitle: "Contact Information",
    address: "Ams Food Market\nGriend 36-15, 8225 TE Lelystad, The Netherlands",
    phone: "064 111 1632",
    email: "amsfoodmarket@hotmail.com",
    whatsapp: "Join our WhatsApp Group",
    googleReview: "Leave a Google Review",
    kvk: "Chamber of Commerce: 87975858",
    openingHoursTitle: "Store Opening Hours",
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
    hours: {
      monTue: "03:00 PM – 07:00 PM",
      wedThuFri: "03:00 PM – 07:00 PM",
      saturday: "08:30 AM – 04:00 PM",
      saturdayNote: "Market Only",
      sunday: "03:00 PM – 07:00 PM",
    },
    locationTitle: "Our Location",
    mapTitle: "Location Ams Food Market Lelystad",
    openInGoogleMaps: "Open in Google Maps",
  },
};